import EditAssignmentForm from "../../../components/Admin/Assignments/EditAssignmentForm";
import Navbar from "../../../components/Navbar";

export default function EditAssignment() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <EditAssignmentForm />
        </div>
      </section>
    </>
  );
}
